export default __webpack_public_path__ + "static/media/cancel-request-icon.e328a02e.svg";